import { postJSON } from "@/utils/http"
// 获取热搜词
export function popularSearches(query) {
  return postJSON("/api/item/popularSearches", query)
}
// 获取搜索联想词
export function multiSuggestions(query) {
  return postJSON("/api/item/searchSuggestions", query)
}
// 获取搜索默认词
export function defaultword(query) {
  return postJSON("/api/item/defaultword", query)
}
